import DecodedToken from './decoded-token.interface';

export function decodeToken(token: string): DecodedToken | null {
  return token ? JSON.parse(atob(token?.split('.')[1])) : null;
}
